import type { RouteType, RouteContext } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import type PlaceFromScheduleStore from "./PlaceFromScheduleStore";

/**
 * Host screen beside the module's own /yard-management. It exists separately
 * because @intrasync/yard-management offers no host extension point — its hub
 * tabs and actions are fixed consts, and YardLayoutModule takes no slot props —
 * so NTX's production-schedule step cannot be injected into it.
 */
const placeFromScheduleRoute: RouteType[] = [
  {
    name: "Place from Schedule",
    title: "Place from Schedule",
    path: "/yard-management/place-from-schedule",
    layout: "/app",
    group: "Yard",
    requiresAuth: true,
    requiresPermission: false,
    enableAutoFind: false,
    viewportCard: {
      header: {
        title: "Place from Schedule",
        enableRefreshButton: true,
        component: () => import("./PlaceFromSchedule.Header"),
      },
      body: {
        component: () => import("./PlaceFromSchedule.Body"),
        grayBackground: true,
      },
    },
    channels: [
      "scheduling/production-schedules",
      "scheduling/sales-orders",
      "scheduling/sales-order-lines",
      "manufacturing/products",
    ],
    onEnter: async ({ rootStore }: RouteContext) => {
      const store = (
        rootStore as RootStore & {
          placeFromScheduleStore?: PlaceFromScheduleStore;
        }
      ).placeFromScheduleStore;
      if (store) await store.loadData();
    },
  },
];

export default placeFromScheduleRoute;
